"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var line_1 = require("./line");
exports.Line = line_1.default;
var density_1 = require("./density");
exports.Density = density_1.default;
var column_1 = require("./column");
exports.Column = column_1.default;
var bubble_1 = require("./bubble");
exports.Bubble = bubble_1.default;
var scatter_1 = require("./scatter");
exports.Scatter = scatter_1.default;
var group_column_1 = require("./group-column");
exports.GroupColumn = group_column_1.default;
var stack_column_1 = require("./stack-column");
exports.StackColumn = stack_column_1.default;
var percentage_stack_column_1 = require("./percentage-stack-column");
exports.PercentageStackColumn = percentage_stack_column_1.default;
var histogram_1 = require("./histogram");
exports.Histogram = histogram_1.default;
var bar_1 = require("./bar");
exports.Bar = bar_1.default;
var stack_bar_1 = require("./stack-bar");
exports.StackBar = stack_bar_1.default;
var percentage_stack_bar_1 = require("./percentage-stack-bar");
exports.PercentageStackBar = percentage_stack_bar_1.default;
var group_bar_1 = require("./group-bar");
exports.GroupBar = group_bar_1.default;
var range_bar_1 = require("./range-bar");
exports.RangeBar = range_bar_1.default;
var range_column_1 = require("./range-column");
exports.RangeColumn = range_column_1.default;
var pie_1 = require("./pie");
exports.Pie = pie_1.default;
var ring_1 = require("./ring");
exports.Ring = ring_1.default;
var radar_1 = require("./radar");
exports.Radar = radar_1.default;
var liquid_1 = require("./liquid");
exports.Liquid = liquid_1.default;
var gauge_1 = require("./gauge");
exports.Gauge = gauge_1.default;
var area_1 = require("./area");
exports.Area = area_1.default;
var stack_area_1 = require("./stack-area");
exports.StackArea = stack_area_1.default;
var percentage_stack_area_1 = require("./percentage-stack-area");
exports.PercentageStackArea = percentage_stack_area_1.default;
var funnel_1 = require("./funnel");
exports.Funnel = funnel_1.default;
var heatmap_1 = require("./heatmap");
exports.Heatmap = heatmap_1.default;
var matrix_1 = require("./matrix");
exports.Matrix = matrix_1.default;
var waterfall_1 = require("./waterfall");
exports.Waterfall = waterfall_1.default;
var treemap_1 = require("./treemap");
exports.Treemap = treemap_1.default;
var step_line_1 = require("./step-line");
exports.StepLine = step_line_1.default;
var word_cloud_1 = require("./word-cloud");
exports.WordCloud = word_cloud_1.default;
var rose_1 = require("./rose");
exports.Rose = rose_1.default;
var bullet_1 = require("./bullet");
exports.Bullet = bullet_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/index.js
// module id = 615
// module chunks = 37